/* istanbul ignore file */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetSupplierAndAIAnswersRequest, SupplierHashRequest } from "@/shared/services/interface/requests/suplier-request";
import { supplierService } from "@/shared/services/api/suplier-service";

export const getSupplierHashThunk = createAsyncThunk(
  "productAnswer/getSupplierHash",
  async ({ hash }: SupplierHashRequest, { rejectWithValue }) => {
    try {
      const response = await supplierService.supplierHash({
        hash,
      });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Bir hata oluştu");
    }
  }
);

export const getSupplierAndAIAnswersThunk = createAsyncThunk(
  "productAnswer/getSupplierAndAIAnswers",
  async ({ specificationId, productId }: GetSupplierAndAIAnswersRequest, { rejectWithValue }) => {
    try {
      const response = await supplierService.getSupplierAndAIAnswers({ specificationId, productId });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Bir hata oluştu");
    }
  }
);

export const getSupplierCategoriesThunk = createAsyncThunk(
  "productAnswer/getSupplierCategories",
  async ({ hash }: SupplierHashRequest, { rejectWithValue }) => {
    try {
      const response = await supplierService.getSupplierCategories(hash);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Bir hata oluştu");
    }
  }
);
